module.exports = __webpack_public_path__ + "static/img/ic_wendu.dd7e91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_wendu.png
// module id = rDTA
// module chunks = 1